export default __webpack_public_path__ + "static/8-b6bb6194aabde495c44a8f6c1f0348e7.png";